module.exports = __webpack_public_path__ + "img/03.de5e7616.png";